import { FC } from "react";

import { Box, Stack } from "@mui/material";

import { useTranslate } from "@/common/hooks/useTranslate";
import { FormIcon } from "@/forms-design-system/FormIcon";
import { FormTypography } from "@/forms-design-system/FormTypography";
import { Lock } from "@/icons/outlined";

interface SupportedProviderHelpProps {
  providerName: string;
  amount: string;
}

export const SupportedProviderHelp: FC<SupportedProviderHelpProps> = ({ providerName, amount }) => {
  const { t } = useTranslate();
  return (
    <Stack
      gap={1}
      sx={(theme) => ({
        position: "fixed",
        left: theme.spacing(3),
        bottom: theme.spacing(3),
        maxWidth: theme.spacing(32),
      })}
    >
      <Stack gap={1.5}>
        <Box
          component="img"
          src="/assets/daf-provider-help.svg"
          alt=""
          sx={(theme) => ({
            width: theme.spacing(22.375),
            height: theme.spacing(26.625),
          })}
        />
        <FormTypography variant="h5" vibe="brand">
          {t("common", "daf.requestTitle", { provider: providerName, amount })}
        </FormTypography>
      </Stack>
      <Stack direction="row" gap={1} alignItems="center">
        <FormIcon size="small">
          <Lock />
        </FormIcon>
        <FormTypography variant="subtitle2" vibe="quiet">
          {t("common", "daf.secured")}
        </FormTypography>
      </Stack>
    </Stack>
  );
};
